import { render, staticRenderFns } from "./DerivedCurve.vue?vue&type=template&id=5abcb0bf"
import script from "./DerivedCurve.vue?vue&type=script&lang=js"
export * from "./DerivedCurve.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports